class TradeSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.trade-partnership__slider');
    if (!this.slider) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    this.slider.addEventListener('mousedown', (e) => {
      isDown = true;
      this.slider.style.cursor = 'grabbing';
      this.slider.style.scrollSnapType = 'none'; // Disable snap while dragging
      startX = e.pageX - this.slider.offsetLeft;
      scrollLeft = this.slider.scrollLeft;
    });

    this.slider.addEventListener('mouseleave', () => {
      isDown = false;
      this.slider.style.cursor = 'grab';
      this.slider.style.scrollSnapType = 'x mandatory';
    });

    this.slider.addEventListener('mouseup', () => {
      isDown = false;
      this.slider.style.cursor = 'grab';
      this.slider.style.scrollSnapType = 'x mandatory';
    });

    this.slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - startX) * 1.5; 
      this.slider.scrollLeft = scrollLeft - walk;
    });

    // Prevent image drag ghosting
    const images = this.querySelectorAll('img');
    images.forEach(img => {
      img.addEventListener('dragstart', (e) => e.preventDefault());
    });
  }
}

customElements.define('trade-slider', TradeSlider);
